import { apiPaths } from '../config/apiPaths';
import { DocumentResponse } from '../modules/InfoPoint/model/DocumentResponse';
import axiosInstance from './axios';

export const getDocuments = (): Promise<DocumentResponse[]> =>
  axiosInstance.get<DocumentResponse[]>(apiPaths.DOCUMENTS_PATH).then(({ data }) => data);
